var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOmiLogo = function SvgOmiLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#omi_logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D2939",
    fillRule: "evenodd",
    d: "M12.364 5.58h.107c3.508 0 6.352 2.783 6.352 6.216a6.094 6.094 0 0 1-1.069 3.453C21.214 15.194 24 12.432 24 9.033c0-3.433-2.844-6.217-6.353-6.217a6.384 6.384 0 0 0-5.283 2.764Zm8.492 15.25c-1.024.265-2.1.407-3.209.407-6.887 0-12.47-5.464-12.47-12.204 0-3.58 1.575-6.8 4.085-9.033C3.93 1.385 0 6.142 0 11.796 0 18.536 5.583 24 12.47 24c3.23 0 6.171-1.2 8.386-3.17Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "omi_logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgOmiLogo;